
module.exports = ['arrow', 'clock', 'pizza-full', 'pizza-left', 'pizza-right', 'plus']
    